const AU_EMPLOYMENT_BASIS_TYPES = {
  full_time: {
    desc: 'Full-time',
  },
  part_time: {
    desc: 'Part-time',
  },
  casual: {
    desc: 'Casual',
  },
  superannuation_annuity: {
    desc: 'Superannuation or annuity income stream',
  },
  labour_hire: {
    desc: 'Labour hire',
  },
} as const;

export default AU_EMPLOYMENT_BASIS_TYPES;
